// Copyright 2017-2021 Dgraph Labs, Inc. and Contributors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { callStartBackup } from "components/Backups/backupModel";

export const SET_BACKUP_CONFIG = "frames/SET_BACKUP_CONFIG";
export const SAVE_START_BACKUP = "frames/SAVE_START_BACKUP ";
export const SAVE_BACKUP_RESULT = "frames/SAVE_BACKUP_RESULT";
export const SAVE_BACKUP_ERROR = "frames/SAVE_BACKUP_ERROR";

export const DEFAULT_BACKUP_CONFIG = {
    backupPath: "",
    destinationType: "nfs",
    forceFull: false,
    overrideCredentials: false,
    anonymous: false,
};

export function setBackupConfig(payload) {
    return {
        type: SET_BACKUP_CONFIG,
        payload,
    };
}

export const setBackupResult = (backupId, result) => ({
    type: SAVE_BACKUP_RESULT,
    backupId,
    result,
});

export const setBackupError = (backupId, err) => ({
    type: SAVE_BACKUP_ERROR,
    backupId,
    err,
});

export const startBackup = (serverUrl, config) => async dispatch => {
    const backupId = `${serverUrl} _ ${Date.now()}`;
    dispatch({
        type: SAVE_START_BACKUP,
        backupId,
        config,
        serverUrl,
        startTime: Date.now(),
    });
    try {
        const res = await callStartBackup(config);
        dispatch(setBackupResult(backupId, res));
    } catch (err) {
        dispatch(setBackupError(backupId, err));
    }
};
